import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingProjectSequence';
import InputBar from '../InputBar';
import BPInput from '../../BionicUI/input/BPInput';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
// import { PostUserSocialRequest } from 'core/models/users/socials/post-user-social.model';
// import { SocialNetworkType } from 'core/models/users/socials/user-social.model';
// import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';

const Telegram = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep, setProgressStep, setProjectInfo, projectInfo } =
    useOnboardingProjectStore();

  async function handleSubmit(inputText: string | null | undefined) {
    if (!inputText) return;
    setProjectInfo('telegramUsername', inputText);
    nextStep();
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Now provide your personal of project Telegram username.',
            sound: 'projectStep/now-provide-personal-project-telegram.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        ></BPInstruction>
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(4)}>
          <BPInput
            value={
              projectInfo?.telegramUsername ? projectInfo.telegramUsername : ''
            }
            state="default"
            type="text"
            placeholder="Enter project telegram username"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => text.length > 3}
          />
          <BPLinkButton onClick={nextStep}>Skip</BPLinkButton>
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default Telegram;
